import $ from 'jquery';
// https://github.com/helpers/handlebars-helpers
import Handlebars from 'handlebars';
// http://assemble.io/helpers/helpers-comparison.html
const helpers = require('handlebars-helpers')();
// https://lodash.com/
const _ = require('lodash');

const $el = {
	requirements: $('#requirements'),
	requirementsInput: $('#requirementsPdfLink'),
};

export default function init() {
	if (!$el.requirements.length) return;
	// check if we have any requirements in storage
	if (localStorage.getItem('options') && localStorage.getItem('products')) {
		requirements();
	}
}

// Show results
function requirements() {
	// Retrieve the template data from the HTML (jQuery is used here).
	const template = $el.requirements.html();
	// Compile the template data into a function
	const templateScript = Handlebars.compile(template);
	// Get results data from local storage	
	const context = _.merge(
		JSON.parse(localStorage.options),
		JSON.parse(localStorage.products),
	);

	// html
	const html = templateScript(context);
	// Insert into form input
	$el.requirementsInput.val(`${location.protocol}//${location.host}${html}`);

}
